import { Component, OnInit } from '@angular/core';
import { UserService } from "../services/user/user.service";
import { ActivatedRoute, ParamMap } from '@angular/router';
@Component({
  selector: 'app-commande-detail',
  templateUrl: './commande-detail.component.html',
  styleUrls: ['./commande-detail.component.css']
})
export class CommandeDetailComponent implements OnInit {
  produits:any;
  total=0;
  constructor(private userService:UserService,private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.userService.getCommande(params.get('id')).subscribe(res=>{
        this.produits = res["data"];
        this.produits.forEach(produit => {
          this.total += parseInt(produit.NETPRI);
        });
      })
    })
  }

}
